(function () {
  'use strict';

  var patchApplied = false;
  var patchInterval = null;
  var ratePromise = null;

  var GAS_RATE_URL = 'https://script.google.com/macros/s/AKfycbwemyGDQOR_rTlxjo27plztTyFaOvtdOczDBBSyG5wrG4-5AraO3d_jhoUHZf1AysBFMg/exec';
  var GAS_RATE_CACHE_KEY = 'gas_usd_uah_rate_v1';
  var GAS_RATE_CACHE_TTL_MS = 30 * 60 * 1000;
  var GAS_RATE_LOCK_KEY = 'gas_usd_uah_rate_lock_v1';
  var GAS_RATE_LOCK_TTL_MS = 30 * 1000;

  function formatUAHFromCents(cents) {
    var whole = Math.floor(Number(cents) / 100);
    return '₴' + whole.toLocaleString('en-US') + ' UAH';
  }

  function formatEURFromCents(cents) {
    var whole = Math.round(Number(cents) / 100);
    return '€' + whole.toLocaleString('en-US') + ' EUR';
  }

  function formatUSDFromCents(cents) {
    var whole = Math.round(Number(cents) / 100);
    return '$' + whole.toLocaleString('en-US') + ' USD';
  }

  function normalizeRenderedMoney() {
    document.querySelectorAll('span.money[doubly-currency]').forEach(function (el) {
      var currency = el.getAttribute('doubly-currency');

      if (currency === 'UAH') {
        var uahCents = el.getAttribute('doubly-currency-uah');
        if (uahCents && isFinite(Number(uahCents))) {
          el.innerHTML = formatUAHFromCents(uahCents);
        }
      }

      if (currency === 'EUR') {
        var eurCents = el.getAttribute('doubly-currency-eur');
        if (eurCents && isFinite(Number(eurCents))) {
          el.innerHTML = formatEURFromCents(eurCents);
        }
      }

      if (currency === 'USD') {
        var usdCents = el.getAttribute('doubly-currency-usd');
        if (usdCents && isFinite(Number(usdCents))) {
          el.innerHTML = formatUSDFromCents(usdCents);
        }
      }
    });
  }

  function clearCurrencyCacheAttributes(targetCurrency) {
    var attrName = 'doubly-currency-' + String(targetCurrency || '').toLowerCase();

    document.querySelectorAll('span.money[' + CSS.escape(attrName) + ']').forEach(function (el) {
      el.removeAttribute(attrName);

      if (el.getAttribute('doubly-currency') === targetCurrency) {
        el.removeAttribute('doubly-currency');
      }
    });
  }

  function getCachedGasRate() {
    try {
      var raw = localStorage.getItem(GAS_RATE_CACHE_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.rate || !parsed.expiresAt) return null;
      if (Date.now() > Number(parsed.expiresAt)) return null;
      if (!isFinite(Number(parsed.rate))) return null;

      return Number(parsed.rate);
    } catch (e) {
      return null;
    }
  }

  function setCachedGasRate(rate) {
    try {
      localStorage.setItem(
        GAS_RATE_CACHE_KEY,
        JSON.stringify({
          rate: Number(rate),
          expiresAt: Date.now() + GAS_RATE_CACHE_TTL_MS
        })
      );
    } catch (e) {}
  }

  function hasRecentFetchLock() {
    try {
      var raw = localStorage.getItem(GAS_RATE_LOCK_KEY);
      if (!raw) return false;
      return Date.now() < Number(raw);
    } catch (e) {
      return false;
    }
  }

  function setFetchLock() {
    try {
      localStorage.setItem(GAS_RATE_LOCK_KEY, String(Date.now() + GAS_RATE_LOCK_TTL_MS));
    } catch (e) {}
  }

  function fetchUsdToUahRateFromGas() {
    var cached = getCachedGasRate();
    if (cached) {
      return Promise.resolve(cached);
    }

    if (hasRecentFetchLock()) {
      return Promise.reject(new Error('Rate fetch locked'));
    }

    setFetchLock();

    return fetch(GAS_RATE_URL, {
      method: 'GET',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch GAS rate: ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.success || !isFinite(Number(data.usd_uah_rate))) {
          throw new Error('Invalid GAS rate payload');
        }

        var rate = Number(data.usd_uah_rate);
        setCachedGasRate(rate);
        return rate;
      });
  }

  function getGasRateOnce() {
    var cached = getCachedGasRate();
    if (cached) {
      return Promise.resolve(cached);
    }

    if (!ratePromise) {
      ratePromise = fetchUsdToUahRateFromGas().catch(function (error) {
        ratePromise = null;
        throw error;
      });
    }

    return ratePromise;
  }

  function patchDoublyConvert(gasRate) {
    if (!window.DoublyGlobalCurrency || typeof window.DoublyGlobalCurrency.convert !== 'function') {
      return false;
    }

    if (window.__doublyConvertPatched) {
      return true;
    }

    var originalConvert = window.DoublyGlobalCurrency.convert.bind(window.DoublyGlobalCurrency);

    window.DoublyGlobalCurrency.convert = function (amount, fromCurrency, toCurrency) {
      var shopCurrency = window.DoublyGlobal && window.DoublyGlobal.shopCurrency
        ? window.DoublyGlobal.shopCurrency
        : 'USD';

      if (
        isFinite(Number(gasRate)) &&
        fromCurrency === shopCurrency &&
        toCurrency === 'UAH'
      ) {
        return Math.round(Number(amount) * Number(gasRate));
      }

      return originalConvert(amount, fromCurrency, toCurrency);
    };

    window.__doublyConvertPatched = true;
    return true;
  }

  function patchDoublyFormatting() {
    if (!window.DoublyGlobalCurrency || !window.DoublyGlobalCurrency.formatMoney) return false;
    if (patchApplied) return true;

    var originalFormatMoney = window.DoublyGlobalCurrency.formatMoney.bind(window.DoublyGlobalCurrency);

    window.DoublyGlobalCurrency.formatMoney = function (cents, format, isShopCurrency, hasSup) {
      var currency = isShopCurrency ? window.DoublyGlobal.shopCurrency : this.currentCurrency;
      var numericCents = Number(cents);

      if (!isFinite(numericCents)) {
        return originalFormatMoney(cents, format, isShopCurrency, hasSup);
      }

      if (currency === 'UAH') {
        return formatUAHFromCents(numericCents);
      }

      if (currency === 'EUR') {
        return formatEURFromCents(numericCents);
      }

      if (currency === 'USD') {
        return formatUSDFromCents(numericCents);
      }

      return originalFormatMoney(cents, format, isShopCurrency, hasSup);
    };

    patchApplied = true;
    return true;
  }

  function refreshDoubly() {
    try {
      if (
        window.DoublyGlobalCurrency &&
        window.DoublyGlobalCurrency.cookie &&
        typeof window.DoublyGlobalCurrency.cookie.read === 'function'
      ) {
        var currency = window.DoublyGlobalCurrency.cookie.read();

        if (currency === 'UAH') {
          clearCurrencyCacheAttributes('UAH');
        }

        if (currency === 'EUR') {
          clearCurrencyCacheAttributes('EUR');
        }

        if (currency === 'USD') {
          clearCurrencyCacheAttributes('USD');
        }

        if (currency && typeof window.DoublyGlobalCurrency.convertAll === 'function') {
          window.DoublyGlobalCurrency.convertAll(currency);
          setTimeout(normalizeRenderedMoney, 30);
          setTimeout(normalizeRenderedMoney, 180);
          setTimeout(normalizeRenderedMoney, 500);
          return;
        }
      }

      if (typeof window.doublyChangeEvent === 'function') {
        clearCurrencyCacheAttributes('UAH');
        clearCurrencyCacheAttributes('EUR');
        clearCurrencyCacheAttributes('USD');

        window.doublyChangeEvent();
        setTimeout(normalizeRenderedMoney, 30);
        setTimeout(normalizeRenderedMoney, 180);
        setTimeout(normalizeRenderedMoney, 500);
      }
    } catch (e) {}
  }

  function ensurePatchAndRefresh() {
    var formatReady = patchDoublyFormatting();
    if (!formatReady) return false;

    getGasRateOnce()
      .then(function (gasRate) {
        patchDoublyConvert(gasRate);
        refreshDoubly();
      })
      .catch(function (error) {
        console.warn('GAS rate fetch failed:', error);
        refreshDoubly();
      });

    return true;
  }

  function startPatchWatcher() {
    if (patchInterval) return;

    var tries = 0;
    patchInterval = setInterval(function () {
      tries++;

      if (ensurePatchAndRefresh() || tries > 20) {
        clearInterval(patchInterval);
        patchInterval = null;
      }
    }, 400);
  }

  function rerun() {
    patchApplied = false;
    startPatchWatcher();

    setTimeout(ensurePatchAndRefresh, 150);
    setTimeout(ensurePatchAndRefresh, 700);

    setTimeout(normalizeRenderedMoney, 150);
    setTimeout(normalizeRenderedMoney, 700);
  }

  document.addEventListener('DOMContentLoaded', rerun);
  window.addEventListener('load', rerun);

  document.addEventListener('theme:section:morphed', function () {
    setTimeout(function () {
      patchDoublyFormatting();
      refreshDoubly();
      normalizeRenderedMoney();
    }, 180);
  });

  document.addEventListener('cart:update', function () {
    setTimeout(function () {
      patchDoublyFormatting();
      refreshDoubly();
      normalizeRenderedMoney();
    }, 180);
  });

  document.addEventListener('cart:rerendered', function () {
    setTimeout(function () {
      patchDoublyFormatting();
      refreshDoubly();
      normalizeRenderedMoney();
    }, 180);
  });

  function refreshDoublyAfterDynamicLoad(event) {
    if (
      event &&
      event.detail &&
      event.detail.gridType &&
      event.detail.gridType !== 'product'
    ) {
      return;
    }

    var delays = [50, 250, 700, 1200, 2000];

    delays.forEach(function (delay) {
      setTimeout(function () {
        ensurePatchAndRefresh();
        normalizeRenderedMoney();
      }, delay);
    });
  }

  window.refreshDoublyAfterDynamicLoad = refreshDoublyAfterDynamicLoad;

  document.addEventListener('dynamic-load:items-added', refreshDoublyAfterDynamicLoad);
})();